import type { GQL_ID } from '@@partner:graphql/types'

import React, { RefObject, useCallback } from 'react'
import { usePreviouslyOrderedProducts } from '@@partner:helpers/hooks/usePreviouslyOrderedProducts'
import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'

import { Divider } from 'rsuite'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import AppLoader from '@components/common/AppLoader'
import ProductSearchItemWidget from './ProductSearchItemWidget'
// TODO: maybe needs replace with another scroller
import InfiniteScroll from 'react-infinite-scroller/dist/InfiniteScroll'

import './PreviouslyOrderedProducts.scss'

export interface PreviouslyOrderedProductsProps {
  shop_id: GQL_ID
  customer_id: GQL_ID
  scrollParentRef: RefObject<any>
  onProductChoose: (...args: any[]) => void
}
export default function PreviouslyOrderedProducts ({
  shop_id,
  customer_id,
  scrollParentRef,
  onProductChoose
}: PreviouslyOrderedProductsProps) {
  const { products, fetchMore, error } = usePreviouslyOrderedProducts(
    customer_id,
    shop_id
  )

  const updaterFunction = useCallback((cached: any, fetched: any) => {
    const prev = cached?.orderedProducts?.edges ?? []
    const curr = fetched?.orderedProducts?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        orderedProducts: {
          ...fetched.orderedProducts,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, fetchNextPage } = useFetchMorePagination({
    fetchMore,
    updaterFunction
  })

  if (error) {
    return <GraphQLCommonErrorDisplay error={error} />
  }

  return (
    <div className="PreviouslyOrderedProducts">
      <Divider className="PreviouslyOrderedProducts__Title">
        Заказанные ранее
      </Divider>
      <InfiniteScroll
        className="PreviouslyOrderedProducts__Items"
        loadMore={fetchNextPage}
        hasMore={hasMore}
        useWindow={false}
        initialLoad={false}
        getScrollParent={() => scrollParentRef.current}
        loader={<AppLoader.RowsWithText content="Загрузка" />}
      >
        {products.map((product: any) => (
          <ProductSearchItemWidget
            key={product.id}
            product={product}
            onProductChoose={onProductChoose}
          />
        ))}
      </InfiniteScroll>
    </div>
  )
}
